<script lang="ts">
    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
    import * as _ from "underscore";
    import type {
        OrganisationResponse,
        Permission,
    } from "../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { organisationStore } from "../../../../store/organisations";
    import { user } from "../../../../store/stores";
    import { usersStore } from "../../../../store/users";
    import PermissionsTable from "./Components/PermissionsTable.svelte";

    export let id: string;

    let organisationDetails: OrganisationResponse;

    let showDeleteOverlay: boolean = false;

    const toggleDeleteOverlay = () => {
        showDeleteOverlay = !showDeleteOverlay;
    };

    const deleteOrga = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .organisationClient.deleteOrganisation({
                    authorization: $user.token,
                    organisationId: id,
                })
                .then(() => {
                    organisationStore.update((organisationStore) => {
                        return {
                            ...organisationStore,
                            organisation: null,
                        };
                    });
                    navigate(-1);
                });
        });
    };

    const updateOrga = async () => {
        await $user.updateToken().then(async () => {
            const updateOrga = organisationDetails;
            await ApiClient.getInstance($user)
                .organisationClient.updateOrganisation({
                    authorization: $user.token,
                    organisationId: organisationDetails.id,
                    organisationRequest: {
                        ...organisationDetails,
                        active: organisationDetails.active,
                    },
                })
                .then((orga) =>
                    organisationStore.update((organisationStore) => {
                        organisationDetails = { ...orga };
                        return {
                            ...organisationStore,
                            organisation: { ...orga },
                        };
                    })
                )
                .catch((err) => alert(err));
        });
    };

    const getOrg = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .organisationClient.getOrganisation({
                    authorization: $user.token,
                    organisationId: id,
                })
                .then((orga) => {
                    organisationStore.update((organisationStore) => {
                        organisationDetails = { ...orga };
                        return {
                            ...organisationStore,
                            organisation: { ...orga },
                        };
                    });
                });
        });
    };

    const getRolesPermissionMapping = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .userAuthorityClient.resolvePermissionsForCurrentUser({})
                .then((permissions) => {
                    user.update((user) => {
                        return {
                            ...user,
                            permissions: [...permissions],
                        };
                    });
                });
        });
    };

    onMount(() => {
        getOrg();
        getRolesPermissionMapping();
    });

    $: changedOrga =
        organisationDetails && $user
            ? _.isEqual(organisationDetails, $organisationStore.organisation)
            : true;

    console.log(organisationDetails);
</script>

<div class="container">
    <div class="block">
        {#if organisationDetails}
            <div class="box">
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">Organisation</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input
                                            class="input "
                                            type="email"
                                            bind:value={organisationDetails.name}
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">Status</label>
                            </div>
                            <div class="field-body">
                                <div class="select">
                                    <select
                                        bind:value={organisationDetails.active}
                                    >
                                        <option value={true}>aktiv</option>
                                        <option value={false}
                                            >deaktiviert</option
                                        >
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/if}
        <div class="columns is-multiline first-row">
            <div
                class="column is-one-third is-flex is-justify-content-flex-start"
            >
                <button class="button" on:click={() => navigate(-1)}>
                    zurück
                </button>
            </div>
            <div
                class="column is-one-third is-offset-one-third is-flex is-justify-content-flex-end"
            >
                <button
                    class="button is-primary is-light"
                    disabled={changedOrga}
                    on:click={() => updateOrga()}
                >
                    Änderungen speichern
                </button>
                <button
                    class="button is-danger is-light"
                    on:click={() => (showDeleteOverlay = true)}
                >
                    Organisation löschen
                </button>
            </div>
        </div>
        {#if showDeleteOverlay}
            <div class="modal is-active">
                <div
                    class="modal-background"
                    on:click={() => toggleDeleteOverlay()}
                />
                <div class="modal-content">
                    <div class="box">
                        <div class="columns is-multiline">
                            <div class="column is-12">
                                <p class="is-size-6">
                                    Möchten Sie diese Organisation wirklich
                                    löschen?
                                </p>
                            </div>
                            <div class="column is-6">
                                <button
                                    class="button is-primary is-light"
                                    on:click={() => toggleDeleteOverlay()}
                                >
                                    Nein
                                </button>
                            </div>
                            <div class="column is-6">
                                <button
                                    class="button is-danger is-light"
                                    on:click={() => deleteOrga()}
                                >
                                    Ja
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    class="modal-close is-large"
                    aria-label="close"
                    on:click={() => toggleDeleteOverlay()}
                />
            </div>
        {/if}
    </div>
</div>

<style>
    .container {
        padding-top: 1rem;
    }
    .box {
        height: 100%;
        overflow: auto;
    }
</style>
